import OrderMatrixLandingPage from './OrderMatrixLandingPage';

export default OrderMatrixLandingPage;
